/* rk-cutoff (22 Oct 2026, Alexander): the dispatch cut-off line under Add to cart (p[data-rk-cutoff], snippets/buy-buttons.liquid).
   Sydney time (Australia/Sydney, daylight saving included):
     00:00 to 14:59  "Order in the next 2h 15m for dispatch tomorrow"   (counting down to 3pm)
     15:00 to 23:59  "Order now, it's processed tomorrow morning"
   Checked every second, written only when the words change, so it costs nothing and follows Shrine's re-render of the buy box. */
(function () {
  if (window.rkCutoff) return; window.rkCutoff = 1;
  var fmt;
  try { fmt = new Intl.DateTimeFormat('en-AU', { timeZone: 'Australia/Sydney', hour: 'numeric', minute: 'numeric', hourCycle: 'h23' }); } catch (e) { return; }
  function text() {
    var p = fmt.formatToParts(new Date()), h = 0, m = 0;
    p.forEach(function (x) { if (x.type === 'hour') h = +x.value; if (x.type === 'minute') m = +x.value; });
    if (h >= 15) return 'Order now, it’s processed tomorrow morning';
    var left = (15 * 60) - (h * 60 + m), hh = Math.floor(left / 60), mm = left % 60;
    return 'Order in the next ' + [hh ? hh + 'h' : '', mm ? mm + 'm' : ''].filter(Boolean).join(' ') + ' for dispatch tomorrow';
  }
  function tick() {
    var nodes = document.querySelectorAll('[data-rk-cutoff]'); if (!nodes.length) return;
    var t = text();
    for (var i = 0; i < nodes.length; i++) if (nodes[i].textContent !== t) nodes[i].textContent = t;
  }
  tick(); setInterval(tick, 1000);
})();
